<template>
    <header class="site-header">
        <a href="#" class="brand-main">
            <img id="logo-desk"
                 style="height: 59px!important;padding-top: 0!important;margin-top: -12px!important;margin-left: -15px!important;"
                 src="/assets/img/logo2.png"
                 alt="Laraspace Logo"
                 class="d-none d-md-inline">
            <img id="logo-mobile"
                 src="/assets/img/logo2.png"
                 alt="Laraspace Logo"
                 class="d-md-none">
        </a>
        <a href="#"
           class="nav-toggle"
           @click="onNavToggle">
            <div class="hamburger hamburger--arrowturn">
                <div class="hamburger-box">
                    <div class="hamburger-inner"/>
                </div>
            </div>
        </a>
        <ul class="action-list">
            <!--<li>-->
            <!--<v-dropdown :show-arrow="false">-->
            <!--<a slot="activator" href="#">-->
            <!--<i class="icon-fa icon-fa-plus"/>-->
            <!--</a>-->
            <!--<v-dropdown-item>-->
            <!--<a href="#">-->
            <!--<i class="icon-fa icon-fa-edit"/> New Post-->
            <!--</a>-->
            <!--</v-dropdown-item>-->
            <!--<v-dropdown-item>-->
            <!--<a href="#">-->
            <!--<i class="icon-fa icon-fa-tag"/> New Category-->
            <!--</a>-->
            <!--</v-dropdown-item>-->
            <!--<v-dropdown-divider/>-->
            <!--<v-dropdown-item>-->
            <!--<a href="#">-->
            <!--<i class="icon-fa icon-fa-star"/> Separated link-->
            <!--</a>-->
            <!--</v-dropdown-item>-->
            <!--</v-dropdown>-->
            <!--</li>-->
            <!--<li>-->
            <!--<v-dropdown :show-arrow="false">-->
            <!--<a-->
            <!--slot="activator"-->
            <!--href="#"-->
            <!--data-toggle="dropdown"-->
            <!--aria-haspopup="true"-->
            <!--aria-expanded="false"-->
            <!--&gt;-->
            <!--<i class="icon-fa icon-fa-bell"/>-->
            <!--</a>-->
            <!--<div class="notification-dropdown">-->
            <!--<h6 class="dropdown-header">-->
            <!--Notifications-->
            <!--</h6>-->
            <!--<v-dropdown-item>-->
            <!--<a class="dropdown-item" href="#">-->
            <!--<i class="icon-fa icon-fa-user"/> New User was Registered-->
            <!--</a>-->
            <!--</v-dropdown-item>-->
            <!--<v-dropdown-item>-->
            <!--<a class="dropdown-item" href="#">-->
            <!--<i class="icon-fa icon-fa-comment"/> A Comment has been posted.-->
            <!--</a>-->
            <!--</v-dropdown-item>-->
            <!--</div>-->
            <!--</v-dropdown>-->
            <!--</li>-->
            <li>
                <v-dropdown :show-arrow="false">
                    <a slot="activator"
                       href="#"
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false"
                       class="dropdown-header">
                        {{$currentUser.name}}
                        <!--<img src="/assets/img/avatars/avatar.png" alt="Avatar">-->
                    </a>
                    <!--<v-dropdown-item>-->
                    <!--<router-link class="dropdown-item" to="/admin/settings">-->
                    <!--<i class="icon-fa icon-fa-cogs"/> Settings-->
                    <!--</router-link>-->
                    <!--</v-dropdown-item>-->
                    <v-dropdown-item>
                        <a href="#"
                           class="dropdown-item"
                           @click.prevent="logout">
                            <i class="icon-fa icon-fa-sign-out"/> Выйти
                        </a>
                    </v-dropdown-item>
                    <v-dropdown-item>
                        <a href="#"
                           class="dropdown-item"
                           @click.prevent="profile">
                            <i class="icon-fa icon-fa-user"/> Профиль
                        </a>
                    </v-dropdown-item>
                    <v-dropdown-item v-if="$currentUser.role == 'admin'">
                        <a href="#"
                           class="dropdown-item"
                           @click.prevent="settings">
                            <i class="icon-fa icon-fa-cogs"/> Настройки
                        </a>
                    </v-dropdown-item>
                    <v-dropdown-item v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                        <a href="#"
                           class="dropdown-item"
                           @click.prevent="users">
                            <i class="icon-fa icon-fa-users"/> Пользователи
                        </a>
                    </v-dropdown-item>
                </v-dropdown>
                <!--<v-dropdown :show-arrow="false">-->
                <!--<a slot="activator"-->
                <!--href="#"-->
                <!--class="dropdown-item"-->
                <!--@click.prevent="logout">-->
                <!--<i class="icon-fa icon-fa-sign-out"/> Выйти-->
                <!--</a>-->
                <!--&lt;!&ndash;<a slot="activator"&ndash;&gt;-->
                <!--&lt;!&ndash;href="#"&ndash;&gt;-->
                <!--&lt;!&ndash;data-toggle="dropdown"&ndash;&gt;-->
                <!--&lt;!&ndash;aria-haspopup="true"&ndash;&gt;-->
                <!--&lt;!&ndash;aria-expanded="false"&ndash;&gt;-->
                <!--&lt;!&ndash;class="avatar">&ndash;&gt;-->
                <!--&lt;!&ndash;User&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<img src="/assets/img/avatars/avatar.png" alt="Avatar">&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;</a>&ndash;&gt;-->
                <!--&lt;!&ndash;<v-dropdown-item>&ndash;&gt;-->
                <!--&lt;!&ndash;<router-link class="dropdown-item" to="/admin/settings">&ndash;&gt;-->
                <!--&lt;!&ndash;<i class="icon-fa icon-fa-cogs"/> Settings&ndash;&gt;-->
                <!--&lt;!&ndash;</router-link>&ndash;&gt;-->
                <!--&lt;!&ndash;</v-dropdown-item>&ndash;&gt;-->
                <!--&lt;!&ndash;<v-dropdown-item>&ndash;&gt;-->
                <!--&lt;!&ndash;<a href="#"&ndash;&gt;-->
                <!--&lt;!&ndash;class="dropdown-item"&ndash;&gt;-->
                <!--&lt;!&ndash;@click.prevent="logout">&ndash;&gt;-->
                <!--&lt;!&ndash;<i class="icon-fa icon-fa-sign-out"/> Logout&ndash;&gt;-->
                <!--&lt;!&ndash;</a>&ndash;&gt;-->
                <!--&lt;!&ndash;</v-dropdown-item>&ndash;&gt;-->
                <!--</v-dropdown>-->
            </li>
        </ul>
    </header>
</template>
<script type="text/babel">
    import Auth from '../../../services/auth'

    export default {
        methods: {
            onNavToggle() {
                this.$utils.toggleSidebar()
            },
            logout() {
                Auth.logout().then(() => {
                    this.$router.replace('/login')
                })
            },
            settings() {
                this.$router.replace('/settings')
            },
            profile() {
                this.$router.replace('/profile')
            },
            users() {
                this.$router.replace('/users')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/layouts/partials/TheSiteHeader.vue